import React, { useMemo } from "react";
import PropTypes from "prop-types";

import TruncatedWithTooltip from "../../../components/TruncatedWithTooltip";
import { UITable, UIToggle } from "../../../components/ui";
import RolesRowActionsMenu from "./RolesRowActionsMenu";

const RolesTable = ({
  rows,
  labels,
  pageSize,
  onView,
  onToggleStatus,
  onEdit,
  onDelete,
  canEdit = true,
  canDelete = true,
}) => {
  const showActions = canEdit || canDelete;

  const columns = useMemo(
    () => [
      {
        field: "name",
        headerName: labels.name,
        sortable: false,
        flex: 1,
        minWidth: 240,
        maxWidth: 320,
        renderCell: ({ value }) => (
          <div className="team-management__name-text">
            <TruncatedWithTooltip title={value}>
              <span className="MuiDataGrid-cellContent">{value}</span>
            </TruncatedWithTooltip>
          </div>
        ),
      },
      {
        field: "usersCount",
        headerName: labels.usersCount,
        sortable: false,
        flex: 1,
        minWidth: 140,
      },
      {
        field: "status",
        headerName: labels.status,
        sortable: false,
        flex: 0.8,
        minWidth: 120,
        renderCell: ({ row }) => (
          <div onClick={(event) => event.stopPropagation()}>
            <UIToggle
              checked={row.active}
              disabled={!canEdit}
              onChange={(checked) => onToggleStatus(row, checked)}
            />
          </div>
        ),
      },
      ...(showActions
        ? [
            {
              field: "actions",
              headerName: labels.actions,
              sortable: false,
              flex: 0.4,
              minWidth: 80,
              align: "right",
              headerAlign: "right",
              renderCell: ({ row }) => (
                <RolesRowActionsMenu
                  row={row}
                  labels={labels}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  canEdit={canEdit}
                  canDelete={canDelete}
                />
              ),
            },
          ]
        : []),
    ],
    [labels, onToggleStatus, onEdit, onDelete, canEdit, canDelete, showActions],
  );

  return (
    <div className="team-management__table team-management__table--clickable">
      <UITable
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        contentSized
        hideFooter
        disableColumnMenu
        disableSelectionOnClick
        getRowId={(row) => row.id}
        rowHeight={70}
        onRowClick={({ row }) => onView(row)}
      />
    </div>
  );
};

RolesTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  pageSize: PropTypes.number,
  onView: PropTypes.func.isRequired,
  onToggleStatus: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool,
  labels: PropTypes.shape({
    name: PropTypes.string.isRequired,
    usersCount: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    actions: PropTypes.string.isRequired,
    edit: PropTypes.string.isRequired,
    remove: PropTypes.string.isRequired,
  }).isRequired,
};

export default RolesTable;
